<template>
    <div>
        <div class="part">
            <p>
                {{
                    $t(
                        "We are providing the global ocean fright service, from-to all countries."
                    )
                }}
            </p>
            <span>
                {{ $t("Will be available very soon!") }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        setAction() {
            this.$buefy.toast.open({
                message: this.$t("Coming Soon!"),
                type: "is-primary",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.part-2 {
    width: 100%;
    height: 100%;
    text-align: left;

    &:lang(ar) {
        text-align: right;
    }

    p {
        width: 85%;
        font-size: 1.2rem;
        line-height: 1.2;
        margin-bottom: 20px;
    }

    .button {
        border-radius: 2px !important;
        padding: 10px 35px;
        margin-bottom: 20px;
        background: #000;
        color: white;
    }
}

.part {
    width: 100%;
    height: 100%;
    text-align: left;
    margin-bottom: 50px;

    &:lang(ar) {
        text-align: right;
    }

    p {
        width: 90%;
        font-weight: bold;
        font-size: 1.8rem;
        line-height: 1.2;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .button {
        border-radius: 2px !important;
        padding: 10px 35px;
        margin-bottom: 20px;
    }
}
</style>
